import React from "react";
import crow from './assets/crow.svg'

const crowStyle = {
    padding: "10vh 0",
    position: "fixed",
};

const Crow = () => {
    return (
        <img className='Crow' src={crow} alt="" style={crowStyle} />
    )
};

export default Crow;
